var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropMedia',{attrs:{"base-url":_vm.baseUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }